import axios from '../utils/axios';

const SERVICE_URL = '/users';
const CLIENT_SERVICE_URL = '/users/client';

export const login = async (username, password) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/login`, { username, password });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userGetPresignedUrlForCfdiByCartId = async (cartId) => {
    try {
        let response = await axios.get(`${SERVICE_URL}/cfdi/get-url/cart/${cartId}`,);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getUser = async (id) => {
    try {
        let response = await axios.post(`${CLIENT_SERVICE_URL}/id?id=${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userRequestPasswordChange = async ({ email, currentPassword, newPassword }) => {
    try {
        const response = await axios.post(`${CLIENT_SERVICE_URL}/request-password-change`, {
            email,
            currentPassword,
            newPassword
        });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}

export const userForgotPassword = async (username) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/forgot-password`, { username });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}

export const userConfirmForgotPassword = async ({ username, code, password }) => {
    try {
        const response = await axios.post(`${SERVICE_URL}/confirm-forgot-password`, {
            username,
            code,
            password
        });
        return response.data;
    } catch (error) {
        return error.response ? error.response.data : error;
    }
}
